import firebase from "firebase";

export const leadsRegisterWithProviders = async data => {
  let callable = firebase
    .functions()
    .httpsCallable("leadsRegisterWithProviders");
  return callable({ ...data }).then(result => result.data);
};
